import React, { Component } from 'react'
import { connect } from 'react-redux';
import numeral from 'numeral'
import AsResponsiveContent from '../airship-wrappers/AsResponsiveContent';
import DpsCategoryWidget from '../DpsCategoryWidget'
import DpsLayerToggle from '../DpsLayerToggle'
import DpsLegendColorContinuousPolygon from '../DpsLegendColorContinuousPolygon'
import DpsLegendCategory from '../DpsLegendCategory'
import * as layers from '../../layers'
import DpsQueryModifier from '../DpsQueryModifier';
import DpsActiveFilters from '../DpsActiveFilters';
import DpsLegendSizeContinuousPoint from '../DpsLegendSizeContinuousPoint';
import { MAP_CONFIG } from '../../MAP_CONFIG';
import { withCarto } from '../../carto/withCarto';
import DpsLoadingIndicator from '../DpsLoadingIndicator';
import AsLegendCategory from '../airship-wrappers/AsLegendCategory';

export class Population extends Component {
  state = {
    ready: false,
    population: undefined,
    dataviewLoading: false,
    isLoadingPopulation: true,
  }

  selectedLayers = ['popweighte', 'popweighteSum']

  constructor(props) {
    super(props)
    this.categoryWidget = React.createRef()
  }

  componentDidMount() {
    this.props.CartoContext.initCarto()
  }

  componentWillUnmount() {
    if (this.state.ready) {
      this.props.CartoContext.dataviews['popweighteSum'].off('dataChanged', this.updateSelected)
      this.props.CartoContext.resetLayers()
    }
  }

  onReady = () => {
    this.props.CartoContext.loadMap(MAP_CONFIG)
    this.props.CartoContext.loadLayers([
      {...layers.wildfire, hide: true},
      {...layers.flood, hide: true},
      {...layers.damInundation, hide: true},
      {...layers.landslide, hide: true},
      {...layers.tsunami, hide: true},
      {...layers.levee, hide: true},
      {...layers.eq1, hide: true},
      {...layers.eq2, hide: true},
      {...layers.slr, hide: true},
      {...layers.popweighte, index: 7, callback: this.mapLoaded},
      layers.municipality,
      layers.kernCounty,
    ])
    this.props.CartoContext.loadDataview(layers.popweighteCategories)
    this.props.CartoContext.loadDataview(layers.popweighteSum)
    this.props.CartoContext.dataviews['popweighteSum'].on('dataChanged', this.updateSelected)
    this.props.CartoContext.addToMap()
    this.setState(state => ({ ...state, ready: true }))
  }

  mapLoaded = (loaded) => {
    this.setState(state => ({
      ...state,
      isLoadingPopulation: loaded !== 'loaded'
    }))
  }

  updateSelected = (data) => {
    this.setState(state => ({
      ...state,
      population: data.result
    }))
  }

  clearFilters = () => {
    this.categoryWidget.current.clearSelection()
    this.selectedLayers.forEach(layer => {
      this.props.CartoContext.clearFilters(layer)
    })
  }

  render() {
    return (
      <AsResponsiveContent onReady={this.onReady}>
        <DpsLoadingIndicator isLoading={this.state.isLoadingPopulation}></DpsLoadingIndicator>
        <aside className="as-sidebar as-sidebar--left" data-name="Jurisdiction">
          <div className="as-container as-p--16">
            {
              this.state.ready &&
              <DpsCategoryWidget ref={this.categoryWidget} dataview="popweighteCategories" selectedLayers={this.selectedLayers} heading="Jurisdiction" field="mun" description="Select population in any jurisdictions"></DpsCategoryWidget>
            }
          </div>
        </aside>
        <main className="as-main">
          <div className="as-map-panels" data-name="Layers">
            {this.state.ready && <div className="as-panel as-panel--top as-panel--right as-body">
              <div className="as-panel__element as-p--16" style={{ minWidth: 200 }}>
                <h4 className="as-subheader">Map Hazard Layers</h4>
                <DpsLayerToggle label="Weighted Population" layer="popweighte" checked>
                  <as-legend>
                    <DpsLegendSizeContinuousPoint layer="popweighte"></DpsLegendSizeContinuousPoint>
                    <DpsLegendColorContinuousPolygon layer="popweighte"></DpsLegendColorContinuousPolygon>
                  </as-legend>
                </DpsLayerToggle>
                <p>Hazard Layer</p>
                <DpsLayerToggle label="M6.8 Concord Green Valley" layer="eq1">
                  <as-legend description="M6.8 Concord Green Valley">
                    <DpsLegendCategory layer="eq1"></DpsLegendCategory>
                  </as-legend>
                </DpsLayerToggle>
                <DpsLayerToggle label="M7.1 Hayward Rodgers Creek" layer="eq2">
                  <as-legend description="M7.1 Hayward Rodgers Creek">
                    <DpsLegendCategory layer="eq2"></DpsLegendCategory>
                  </as-legend>
                </DpsLayerToggle> 
                <DpsLayerToggle label="FEMA Flood Hazard" layer="flood">
                  <as-legend>
                    <DpsLegendCategory layer="flood"></DpsLegendCategory>
                  </as-legend>
                </DpsLayerToggle>
                <DpsLayerToggle label="Dam Inundation" layer="damInundation">
                  <as-legend>
                    <AsLegendCategory slot="legends" orientation="vertical" data={[{type: 'point', color: "#81ccb4", label: "Dam Inundation"}]}></AsLegendCategory>
                  </as-legend>
                </DpsLayerToggle>
                <DpsLayerToggle label="Wildfire" layer="wildfire">
                  <as-legend>
                    <DpsLegendCategory layer="wildfire"></DpsLegendCategory>
                  </as-legend>
                </DpsLayerToggle>
                <DpsLayerToggle label="Landslide" layer="landslide">
                  <as-legend>
                    <DpsLegendCategory layer="landslide"></DpsLegendCategory>
                  </as-legend>
                </DpsLayerToggle>
                <DpsLayerToggle label="Tsunami Runup Area" layer="tsunami">
                  <as-legend>
                    <DpsLegendCategory layer="tsunami"></DpsLegendCategory>
                  </as-legend>
                </DpsLayerToggle>
                <DpsLayerToggle label="Area Protected by Levee" layer="levee">
                  <as-legend>
                    <DpsLegendCategory layer="levee"></DpsLegendCategory>
                  </as-legend>
                </DpsLayerToggle>
                <DpsLayerToggle label="Sea Level Rise (By Scenario of Rise)" layer="slr">
                  <as-legend>
                    <DpsLegendCategory layer="slr"></DpsLegendCategory>
                  </as-legend>
                </DpsLayerToggle>
                <p>Base Map</p>
                <DpsLayerToggle label="Solano County" layer="kernCounty" checked>
                </DpsLayerToggle>
                <DpsLayerToggle label="Municipality" layer="municipality" checked>
                </DpsLayerToggle>
              </div>
            </div>}
          </div>
          <div className="as-map-panels" data-name="Summary">
            {this.state.ready &&  <div className="as-panel as-panel--top as-panel--left" style={{ display: 'flex', flexDirection: 'column' }}>
              <div className="as-panel__element as-p--16 as-body" style={{ minWidth: 200 }}>
                <span>Selected Population</span>
                <br />
                <span style={{ margin: 0, fontSize: '1.5em', fontWeight: 'bold' }}>{this.state.population !== undefined ? numeral(this.state.population).format('0,0') : 'Loading'}</span>
              </div>
              <div className="as-panel__element as-p--16 as-body" style={{ minWidth: 200 }}>
                <h4 className="as-subheader">Vulnerability Data</h4>
                <p style={{ marginTop: 0 }}>Population Risk Filters</p>
                <DpsQueryModifier label="M6.8 Concord Green Valley" layerNames={this.selectedLayers} field="haz_eq1" values={['Severe', 'Very Strong','Strong']}></DpsQueryModifier>
                <DpsQueryModifier label="M7.1 Hayward Rodgers Creek" layerNames={this.selectedLayers} field="haz_eq2" values={['Severe', 'Very Strong','Strong']}></DpsQueryModifier>
                <DpsQueryModifier label="FEMA Flood Risk" layerNames={this.selectedLayers} field="haz_fld" values={['100yr','100yr Coastal', '500yr', 'PROTECTED BY LEVEE']}></DpsQueryModifier>
                <DpsQueryModifier label="Dam Inundation Risk" layerNames={this.selectedLayers} field="haz_damg" values={['Yes']}></DpsQueryModifier>
                <DpsQueryModifier label="Wildfire Risk" layerNames={this.selectedLayers} field="haz_wf" values={['Very High', 'High', 'Moderate']}></DpsQueryModifier>
                <DpsQueryModifier label="Landslide Risk" layerNames={this.selectedLayers} field="haz_ls" values={['High', 'Medium', 'Low']}></DpsQueryModifier>
                <DpsQueryModifier label="Tsunami Runup" layerNames={this.selectedLayers} field="haz_tsu" values={['Yes']}></DpsQueryModifier>
                <DpsQueryModifier label="Area Protected by Levee" layerNames={this.selectedLayers} field="haz_lev" values={['Yes']}></DpsQueryModifier>
                <DpsQueryModifier label="Sea Level Rise (By Scenario of Rise)" layerNames={this.selectedLayers} field="haz_slr" values={['Low','Intermediate Low','Intermediate','Intermediate High','High','Extreme']}></DpsQueryModifier>
              </div>
              <div className="dps-mx-8">
                <DpsActiveFilters selectedLayers={[{layerName: 'popweighte', label: 'Selected Population'}]} minWidth={200}></DpsActiveFilters>
                <button className="as-panel__element as-btn as-btn--complementary" style={{ color: '#FFF', justifyContent: 'center', width: '100%' }} onClick={this.clearFilters}>Clear All Filters</button>
              </div>
            </div>
            }
          </div>
          <div className="as-map-area">
            <div id="map"></div>
          </div>
        </main>
      </AsResponsiveContent>
    )
  }
}

const mapStateToProps = state => ({
  layers: state.carto.layers,
  dataviews: state.carto.dataviews
});

export default connect(mapStateToProps)(withCarto(Population))
